import { render } from "./manageWorkflow.vue?vue&type=template&id=819c57a4&scoped=true&ts=true"
import script from "./manageWorkflow.vue?vue&type=script&lang=ts"
export * from "./manageWorkflow.vue?vue&type=script&lang=ts"

import "./manageWorkflow.vue?vue&type=style&index=0&id=819c57a4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-819c57a4"]])

export default __exports__